/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, Input, OnInit} from '@angular/core';
import {person} from "../model/person";
import {PersonService} from "../services/person.service";
declare var $:any;

@Component({
    selector: 'app-person-detail',
    templateUrl: './person-detail.component.html',
    styleUrls: ['./person-detail.component.less'],
    standalone: false
})
export class PersonDetailComponent implements OnInit {

  @Input() person: person;

  constructor(private personService: PersonService) { }

  ngOnInit() {
    this.person = new person();
  }

  SavePerson(){
    if (this.person.firstName.length>0 && this.person.lastName.length>0)
      this.personService.addPerson(this.person).subscribe(x=>{
        this.person.personID = x.personID;
      },(error)=>{
        alert("There is error when adding this person");
      },()=>{
        this._returnBackParentWindow();
      });
    else
      alert('Please enter all required fields.');
  }

  ResetFields(){
    this.person = new person();
  }

  private _returnBackParentWindow(){
    $('button.closeModal',parent.document).attr("personid",this.person.personID);
    $('button.closeModal',parent.document).click();
  }
}
